import React, {PropsWithChildren} from "react";
import {SCENE, WithScene} from "../../../interfaces/UX";
import {ActionButton} from "../../../components/action-button/ActionButton";

export const DORoomManager = (props: PropsWithChildren<WithScene>) => {

    return (
        <ActionButton onClick={() => {props.changeScene(SCENE.MAIN)}}>
            +
        </ActionButton>
    );
};
